import type { GridRenderEditCellParams } from '@mui/x-data-grid-pro'
import type { ComponentType } from 'react'

export type EditorComponentProps = GridRenderEditCellParams & {
	componentOptions: Record<string, unknown>
}

export type EditorComponent = ComponentType<EditorComponentProps>

const registry: Map<string, EditorComponent> = new Map()

export const registerEditComponent = (key: string, component: EditorComponent): void => {
	registry.set(key, component)
}

export const getEditComponent = (key: string): EditorComponent | undefined => {
	return registry.get(key)
}

export const hasEditComponent = (key: string): boolean => {
	return registry.has(key)
}
